import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISTCConfigsData, STCConfigsModel } from '../models/stcconfigs_model';

angular
  .module('capability-ng-priority-feed')
  .factory(
    'getSTCConfigsCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      appConfigModel: any,
      authToken: any,
      ngSTCConfigsModel: STCConfigsModel
    ): ICommand => {
      return defineCommandORM('getSTCConfigsCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
        const campusUrl = appConfigModel.getConfigProperty(`core-campus_url`);
        if (_4.isEmpty(campusUrl)) {
          deferred.resolve();
          return;
        }
        authToken
          .campusTokenRequest({
            url: '/api/v3/configs'
          })
          .then(({ data }: any) => {
            ngSTCConfigsModel.write(data);
            localStorage.setItem('eab.navigate.alert_name', JSON.stringify(data.alert_label));
            localStorage.setItem('eab.navigate.self_alerts_title', JSON.stringify(data.self_alert_label));
            deferred.resolve(data);
          })
          .catch((err: Error) => {
            deferred.reject(err);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/get_stc_configs_command.ts